import React, { Component } from 'react';
import { connect } from 'react-redux';
import MicroModal from 'micromodal'; 
import { handleConfirmEnableNc2Redux } from '../actions';
import Moment from 'moment';
import { toast } from "react-toastify";
import _ from 'lodash'

var date = Moment().format('YYYY-MM-DD')
var time = Moment().format('HH:mm')
var clean = false;
var keycount = 1;

const mapDispatchToProps = dispatch => {
  return {
      handleConfirmEnableNc2: (params) => {
        dispatch(handleConfirmEnableNc2Redux(params,true))
      }
    };
};

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
    IPCurrent: state.ipcurrent,
    ContactId: state.atendimento,
  };
}

 class NoteNc2Modal extends Component {
        constructor(props) {
            super(props);
            this.state = {
              arrayReason: [{tipo: 15, descricao: 'teste1', idFila: 6},{tipo: 12, descricao: 'teste2', idFila: 6}],
              arrayNumber: [{fone: '71982718640'},{fone: '71983481278'}],
              numberIdSelect: 0,
              numberSelect: '0',
              reasonSelect: 'Selecione  ',
              frequenceCall: true,
              checkAnswerSched: true,
              textAgend: '',
              reasonIdSelect: 0,
              initCheck: true,
              idFila: 0,
              timeDiff: 0,
              especificoType: true,
              genericoType: true
            };
        }

        componentDidUpdate(prevProps, prevState){
            if(prevProps.InfoUsers.numbersnc2.length !== 0 && prevProps.ContactId.length !== 0 && prevState.initCheck === true && !prevProps.InfoUsers.nc2schedule){
                let checkNumberRadio = false;
                prevState.arrayNumber.map((number, index) => {
                       document.getElementById("telefon"+index).checked = false;
                       document.getElementById("telefone9999").checked = false;
                })
                prevState.arrayNumber.map((number, index) => {
                   if(number.fone.trim() === prevProps.ContactId.telefone.trim()){
                       this.setState({numberSelect: number.fone})
                       this.setState({numberIdSelect: 'telefon'+index})
                       document.getElementById("telefon"+index).checked = true;
                       checkNumberRadio = true;
                   }
                })
                if(!checkNumberRadio){
                    this.setState({numberSelect: prevProps.InfoUsers.numbersnc2[0].fone})
                    this.setState({numberIdSelect: '0'});
                    document.getElementById("telefon0").checked = true;
                }
           
               this.setState({initCheck: false})
             } 

             if(prevProps.InfoUsers.nc2schedule){
                clean = true;
             }

             if(clean && prevProps.InfoUsers.nc2schedule === false && prevProps.InfoUsers.paramsnc2.length === 0){
                this.clearValues();
                clean = false;
             }
           
        }

    confirmAgend(ipcurrent){
        var betwenDate = Moment().format('YYYY/MM/DD HH:mm:ss');

		var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

		if(parseInt(ipcurrent.difftime)<0){
			betwenDate = Moment().subtract(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
		}else{
			betwenDate = Moment().add(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
		}

        // var betwenDate = Moment().format('YYYY-MM-DD HH:mm')
        var dateCompare = this.date.value+' '+this.time.value;

        var result = Moment(dateCompare).isBetween(betwenDate, '2050-10-25 23:59');

        
        if(result === false){
            if(this.state.idFila !== 3 && this.state.idFila !== 4){
                toast.info('Data inválida!', {
                    position: "bottom-right",
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: true,
                    autoClose: 5000
                }); 
                return true
            }
        }

        if(this.state.reasonIdSelect !== 0){

            let especifica = this.state.frequenceCall ? 1:0;
            let proximoligacao = this.date.value+' '+this.time.value+':00';
            let resultado = this.state.reasonIdSelect;
            let telefone = this.state.numberSelect.trim();

            if(this.state.numberIdSelect === 'telefon'){
                telefone = document.getElementById("telefone9999").value
                if(telefone !== ""){
                    var checkNumber = false;
                    this.state.arrayNumber.map((number, index) => {
                        if(telefone.trim() === number.fone.trim()){
                            checkNumber = true;
                        }
                    })
                    if(checkNumber){
                        toast.info('Telefone já existente!', {
                            position: "bottom-right",
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: true,
                            autoClose: 5000
                        }); 
                        return true
                    }
                }
            }

            if(telefone === ""){
                if(this.state.idFila !== 3 && this.state.idFila !== 4){
                    toast.info('Campo telefone em branco!', {
                        position: "bottom-right",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: true,
                        autoClose: 5000
                    }); 
                    return true
                }
            }


            if(telefone.length <= 9 || telefone.length >= 13){
                if(this.state.idFila !== 3 && this.state.idFila !== 4){
                    toast.info('Número inválido!', {
                        position: "bottom-right",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: true,
                        autoClose: 5000
                    }); 
                    return true
                }
            }



            if(this.state.idFila === 3 || this.state.idFila === 4){
                proximoligacao = null;
                especifica = 0;
            }

            let json = {
                    resultado: resultado, 
                    proximoligacao: proximoligacao,
                    especifica: especifica,
                    telefone: telefone.trim()
                }


            this.props.handleConfirmEnableNc2(json)
            MicroModal.close('modal__encerrar-atendimento')
            // this.clearValues();
            }else{
                toast.info('Selecione um resultado!', {
                    position: "bottom-right",
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: true,
                    autoClose: 5000
                  }); 
            }

    }

    clearValues(){
        this.setState({initCheck: true, numberIdSelect: 0, numberSelect: '0', initCheck: true,  idFila: 0, reasonSelect: 'Selecione', frequenceCall: true, reasonIdSelect: 0, genericoType: true, especificoType: true})
        this.state.arrayNumber.map((array, index) => {
            var myCheckbox15 = document.getElementById("telefon"+index);
            myCheckbox15.checked = false;
        })
        // var myCheckbox11 = document.getElementById('telefon0');
        //     myCheckbox11.checked = true;
        var myCheckbox12 = document.getElementById("telefon");
            myCheckbox12.checked = false;   
            document.getElementById("telefone9999").value = '';
    }

    handleCheckbox(value,posit){
        var myCheckbox0 = document.getElementById("telefon");
        myCheckbox0.checked = false;
        this.state.arrayNumber.map((array, index) => {
            var myCheckbox1 = document.getElementById("telefon"+index);
            myCheckbox1.checked = false;
        })
        var myCheckbox2 = document.getElementById(posit);
        myCheckbox2.checked = true;
        this.setState({numberSelect: value, numberIdSelect: posit, initCheck: false})
    }

    handleResultado(e,idFila,array){
        this.setState({reasonSelect: array.descricao,reasonIdSelect: array.idResultado, visible: false, idFila: array.idFila, timeDiff: array.segundo})
        if(idFila !== 3 && idFila !== 4){
            var teste = Moment().format('YYYY-MM-DD HH:mm')
           teste = Moment().add(array.segundo, 'seconds')
            teste = Moment(teste).format('YYYY-MM-DD HH:mm')
            this.date.value = Moment(teste).format('YYYY-MM-DD')
            this.time.value = Moment(teste).format('HH:mm')
        }

        let especificoType = (array.tipo & 2) > 0;
        let genericoType = (array.tipo & 1) > 0;

        this.setState({especificoType: especificoType})
        this.setState({genericoType: genericoType})

        if(especificoType && genericoType)
            this.setState({frequenceCall: true})
        else if(especificoType && genericoType === false)
            this.setState({frequenceCall: true})
        else if(especificoType === false && genericoType)
            this.setState({frequenceCall: false})
      
    }

render(){

  const {InfoUsers,IPCurrent,ContactId} = this.props;

  if(InfoUsers.reasonsnc2 !== undefined){
     var chars = InfoUsers.reasonsnc2;
     this.state.arrayReason = _.orderBy(chars, ['descricao'],['cres']); // Use Lodash to sort array by 'name'
   }

  if(InfoUsers.numbersnc2 !== undefined)
     this.state.arrayNumber = InfoUsers.numbersnc2;

    return(  
        <div className="modal micromodal-slide" id="modal__encerrar-atendimento" aria-hidden="true" role="dialog">
            <div className="modal__overlay" tabIndex="-1">
                <div className="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal__calendario-evento-editar__title">
                    <header className="modal__header">
                    <div className="title-column">
                        <h2 className="modal__title is-poppins">
                        Agende a proxima ligação
                        </h2>
                        <p className="modal__subtitle">Preencha os campos abaixo para agendar uma ligação</p>
                    </div>
                    <button className="modal__close" aria-label="Close modal" data-micromodal-close></button>
                    </header>
                    <main className="modal__content" id="modal__calendario-evento-editar__content">
                    <form action="#" className="modal__content__form">
                        {/* <!-- LINHA 1 -->
                        <!-- titulo --> */}
                        <div className="form__field">
                            <div className="modal__content__form__group">
                                <label className="modal__content__form__group__label">
                                Resultado da ligação:
                                </label>
                                <div className="pausa">
                                    <a className={this.state.visible ? "calendario-select active":"calendario-select"} onClick={() => this.setState({visible: !this.state.visible})}>
                                        <div className="text">{this.state.reasonSelect}</div>
                                        <i className="material-icons">chevron_right</i>
                                    </a>
                                    <div className={this.state.visible ? "pausa__select active":"pausa__select"}>
                                        <ul className="pausa__list">
                                            {this.state.arrayReason.map(array => 
                                        <li className="pausa__item" onClick={event => this.handleResultado(event,array.idFila,array)} key={keycount++}>
                                                <p className="pausa__label">{array.descricao}</p>
                                            </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{display: this.state.idFila !== 3 && this.state.idFila !== 4 ? 'block':'none'}}>
                                    {/* <div className="form__field">
                                        <div className="modal__content__form__group">
                                            <label className="modal__content__form__group__label">
                                            Observações:
                                            </label>
                                            <textarea className="form__field__textarea" value={this.state.textAgend} onChange={event => this.setState({textAgend: event.target.value})}></textarea>
                                        </div>
                                    </div> */}
                                    <div className="form__field">
                                        <div className="modal__content__form__group">
                                            <label className="modal__content__form__group__label">
                                            Informações do cliente:
                                            </label>
                                            <div className="form__field__content form__field__content--column ">
                                                {/* <button className="btn btn-primary">Adicionar novo numero</button> */}
                                                <div className="form__field__content__input-container">
                                                    {this.state.arrayNumber.map((number, index) => 
                                                    <div className="modal__content__form__group__input modal__content__form__group__input--tell">
                                                        <input type="radio" id={'telefon'+index} name={'telefon'+index} onClick={e => this.handleCheckbox(number.fone, 'telefon'+index)} defaultChecked={this.state.numberIdSelect === index} />
                                                        <i className="material-icons">call</i>
                                                        <input type="text" disabled={true} value={number.fone} name="telefone" className="modal__content__form__group__input" />
                                                    </div>
                                                    )}
                                                    <div className="modal__content__form__group__input modal__content__form__group__input--tell">
                                                        <input type="radio" id='telefon' name='telefon'  onClick={e => this.handleCheckbox(document.getElementById("telefone9999").value, 'telefon')} />
                                                        <i className="material-icons">call</i>
                                                        <input type="number" name="telefone9999" id="telefone9999" className="modal__content__form__group__input" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form__field">
                                        <div className="modal__content__form__group">
                                            <label className="modal__content__form__group__label">
                                            Essa ligação deverá ser feita:
                                            </label>
                                            <ul className="tg-list">
                                            <li className="tg-list-item" >
                                                <input className="tgl tgl-light" id="cb1" type="checkbox" disabled={this.state.especificoType === false || this.state.genericoType === false ? true:false} onClick={() => this.setState({frequenceCall: !this.state.frequenceCall})} defaultChecked={this.state.frequenceCall ? false:true} />
                                                <label className="tgl-btn" htmlFor="cb1"></label>
                                                <div className="tg-list-item__options">
                                                    {this.state.especificoType && <div className="text" id="por-mim">Especifíco</div>}
                                                    {this.state.genericoType && <div className="text" id="por-todos" style={{marginRight: -15}}> Genérico</div>}
                                                </div>
                                            </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="form__field">
                                    {/* <div className="modal__content__form__group">
                                        <label className="modal__content__form__group__label">
                                        Ligar em que momento:
                                        </label>
                                        <div className="container-input-modal">
                                        <li className="container-input-modal__item">
                                            <input className="input__radius" id="r2" type="radio" name="radio" onChange={() => this.setState({checkAnswerSched: !this.state.checkAnswerSched})} checked={this.state.checkAnswerSched ? true:false} />
                                            <label htmlFor="r2">Ligar agora</label>
                                        </li>
                                        <li className="container-input-modal__item">
                                            <input className="input__radius" id="r3" type="radio" name="radio" onChange={() => this.setState({checkAnswerSched: !this.state.checkAnswerSched})} checked={this.state.checkAnswerSched ? false:true} />
                                            <label htmlFor="r3">Agendar</label>
                                        </li>
                                        </div>
                                    </div> */}
                                    </div>
                                    <div className="form__field">
                                    {/* <!-- data --> */}
                                    <div className="modal__content__form__group">
                                        <label className="modal__content__form__group__label" htmlFor="modal__content__form__group__label--data">
                                        Agendar ligação:
                                        </label>
                                        <input type="date" ref={input => this.date = input} min={date} defaultValue={date} name="data" className="input-text" id="modal__content__form__group__label--data" />
                                    </div>
                                    {/* <!-- hora --> */}
                                    <div className="modal__content__form__group">
                                        
                                        <input type="time" ref={input => this.time = input} defaultValue={time} name="contato" className="modal__content__form__group__input" id="modal__content__form__group__label--hora" />
                                    </div>
                                    </div>
                        </div>
                                    {/* <!-- tipos de assunto -->
                        <!-- BUTTONS --> */}
                        <div className="form__field flex-end">
                        <a className="modal__content__form__group__button modal__content__form__group__button--white" data-micromodal-close>
                            Cancelar
                        </a>
                        <a className="modal__content__form__group__button" onClick={() => this.confirmAgend(IPCurrent)}>
                            Confirmar
                        </a>
                        </div>
                        {/* <!-- END BUTTONS --> */}
                    </form>
                    </main>
                </div>
            </div>
        </div>
)}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(NoteNc2Modal);